import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
}), 'ArrowRightAlt');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowRightAlt.js
// module id = 2114
// module chunks = 2